import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import useBem from '@indicia/use-bem';

import './Dialog.scss';

type DialogPropType = {
  content: ReactNode;
  title?: string;
  onClose: () => void;
  actions?: ReactNode;
};

const Dialog = ({ content, onClose, title = undefined, actions = null }: DialogPropType) => {
  const { bemClassName } = useBem('dialog');

  const dialogContent = (
    <div className={bemClassName()}>
      <button
        className={bemClassName('overlay')}
        type="button"
        onClick={onClose}
      >
        Scherm sluiten
      </button>
      <dialog
        className={bemClassName('popup')}
        open
      >
        {title && (
          <div className={bemClassName('header')}>
            <h2>{title}</h2>
          </div>
        )}
        <div className={bemClassName('content')}>{content}</div>
        {actions && <div className={bemClassName('footer')}>{actions}</div>}
      </dialog>
    </div>
  );

  return createPortal(dialogContent, document.body);
};

export default Dialog;
